import { c as _c } from "react/compiler-runtime";
import React, { FC } from "react";
import { CtaWithTextProps } from "./types";
import SecondVariant from "./SecondVariant";
import FirstVariant from "./FirstVariant";
const CtaWithText: FC<CtaWithTextProps> = t0 => {
  const $ = _c(4);
  const {
    data
  } = t0;
  if (data.variant === "second") {
    let t1;
    if ($[0] !== data) {
      t1 = <SecondVariant data={data} />;
      $[0] = data;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  } else {
    let t1;
    if ($[2] !== data) {
      t1 = <FirstVariant data={data} />;
      $[2] = data;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
};
export default CtaWithText;